export default __webpack_public_path__ + "static/media/img_240.8b255ade.jpg";